/* global rp$, document, window */
const get = require('lodash/get');
const paypalSmartButtons = require('../../../js/components/paypal-smart-buttons');

var THE_SCRIPT = function() {
	const $onReady = require("public/js/lib/on-ready");
	const { validatePostalCode } = require('public/js/lib/postal-code-helper');

	(function ProductInventoryMessagingModule() {
		function HandleInventoryMessageResponse({
			$inventoryMessageContentEle,
			$addToCartBtn,
			$inventoryWrap
		}) {
			return function(evt, response) {
				// Unset `Add To Cart` button's data attribute (data-inventory-message)
				// when no `inventoryMessage`
				const responseInventoryMessage = response.inventoryMessage ? response.inventoryMessage : '';
				const responseInventoryType = response.inventoryMessageType ? response.inventoryMessageType : '';

				$inventoryMessageContentEle.text(responseInventoryMessage);
				$addToCartBtn.attr(
					"data-inventory-message",
					responseInventoryMessage
				);

				$inventoryWrap.removeClass('product-in-stock-message');
				if (responseInventoryType === 'StockLevel') {
					$inventoryWrap.addClass('product-in-stock-message');
				}

				$inventoryWrap.attr("hidden", responseInventoryMessage === '');

				// Update the tracking value to accurately depict what's on the page
				if (responseInventoryType && window.tracking && (typeof window.tracking.dimensions === 'object')) {
					window.tracking.dimensions.stockLevelMessaging = responseInventoryType;
				}
			};
		}

		function HandleDealerSelect(evt) {
			evt.preventDefault();
			const dealerHash = rp$(this).data("fulfillment-hash");
			if(!dealerHash ) {
				return;
			}

			$ajax({
				method: "POST",
				dataType: "json",
				url: "/ajax/dealers",
				data: {
					dealerHash
				},
				success: (response, status /*, xhr*/) => {
					if (status === "success") {
						rp_app.location.reload();
					}
				}
			});
		}

		function HandleViewMoreDealers(evt) {
			evt.preventDefault();

			window.rp_app.request({
				type: 'GET',
				url: '/ajax/cart',
				dataType: 'json',
				contentType: 'application/json',
				success: HandleViewMoreDealersRedirect,
			});
		}

		function HandleViewMoreDealersRedirect(cart) {
			const cartHasItems = !!get(cart, 'itemsCount');
			if (cartHasItems) {
				const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				if ($dealerSelectionWarningModal) {
					$dealerSelectionWarningModal.modal();
				}
			} else {
				ClearSelectedDealer();
			}
		}

		function ClearSelectedDealer() {
			$ajax({
				method: "GET",
				dataType: "json",
				url: "/ajax/dealers/clear",
				success: (response, status /*, xhr*/) => {
					if (status === "success") {
						rp_app.location.reload();
					}
				}
			});
		}

		$onReady({
			rp$,
			window,
			label: "product_purchase",
			fn: function() {
				const $inventoryMessageContentEle = rp$("#rp_inventory_message");
				const $addToCartBtn = rp$(".product-purchase button.add-to-cart");
				const $inventoryWrap = rp$("#inventory_wrap");
				if ($inventoryMessageContentEle && $addToCartBtn) {
					const eventHandler = HandleInventoryMessageResponse({
						$inventoryMessageContentEle,
						$addToCartBtn,
						$inventoryWrap
					});

					/* Handle inventory message Response
					.*-----------------------------------------*/
					// Due to plugin, all things that depend on document and window are up for causing bugs. Lets clean up before we start
					rp$(document).off(
						"productGetInventoryMessage:response",
						eventHandler
					);
					rp$(document).on("productGetInventoryMessage:response", eventHandler);
				}

				const $dealerSelect = rp$(".offer-dealer-list .dealer-select-button");
				if ($dealerSelect && $dealerSelect.length > 0) {
					$dealerSelect.each(function() {
						rp$(this).on("click", HandleDealerSelect);
					})
				}

				const $viewOffersLink = rp$(".purchase-box .view-offers-link");
				if ($viewOffersLink) {
					$viewOffersLink.on("click", HandleViewMoreDealers);
				}

				// viewOffersLink -> dealerSelectionWarningModal
				const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				const $warningModalContinueButton = rp$(".continue-button", $dealerSelectionWarningModal);
				$warningModalContinueButton.on("click", ClearSelectedDealer);

				// adding paypal payment message

				let sale_price = '';
				try {
					sale_price = rp$('.product-purchase-module').data('sale-price');
				} catch (e) {/* do nothing if sale price is empty or not having value */}

				const paymentsMessageContainerClass = '.pp-message';
				const paymentsMessageData = {
					elemOrSelector: paymentsMessageContainerClass,
					amount: sale_price,
					placement: 'product',
				}
				paypalSmartButtons.initPaypalMessage(paymentsMessageData);
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
